<mat-form-field appearance="outline" class="w-100  m-t-5" [ngClass]="{
  'mat-form-field-compact': size === 'compact',
  'mat-form-field-xs': size === 'xs'}">
    <textarea matInput style="resize: none;" [formControl]="control" [placeholder]="placeholder"></textarea>
</mat-form-field>
<app-error [control]="control" [type]="'textarea'" [customStyle]="customErrorStyle"></app-error>